import { css } from "../../styled-system/css";
import Header from "./header";
import { LoadingIcon } from "./loadingIcon";

export function PageLoading() {
  return (
    <>
      <Header title="" />
      <div
        className={css({
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bg: "background.background",
        })}
      >
        <LoadingIcon />
      </div>
    </>
  );
}
